import Lottie from 'lottie-react';

import dotstormingLogoCompact from '../../../assets/dotstorming-logo-compact.json';

export function DotstormingPageLoader() {
  return (
    <Lottie
      animationData={dotstormingLogoCompact}
      loop
      autoplay
      style={{ height: 100, width: 100 }}
      aria-label="Loading wall"
    />
  );
}
